export const generativeAiAgentIdVersionDiff = "/generative_ai/agent/:id/version/:version/diff";
